// @flow
import React, { Component } from 'react';
import { type Location, type RouterHistory } from 'react-router-dom';
import queryString from 'query-string';
import {AuthActions, CartActions, WishActions, UserActions} from 'store/actionCreators';
import { connect } from 'react-redux';
import type { State } from 'store';
import type { AuthResult } from 'store/modules/auth';
import storage, { keys } from 'lib/storage';

type Props = {
  location: Location,
  history: RouterHistory,
  authResult: AuthResult,
};

class EmailLogin extends Component<Props> {
  initialize = async () => {
    const { search } = this.props.location;
    const { code, next } = queryString.parse(search);
    const { history } = this.props;
    try {
      await AuthActions.codeLogin(code);
      const { authResult } = this.props;

      if (!authResult) return;
      const { token, user } = authResult;

      await UserActions.setUser(user);
      await CartActions.getCart();
      await WishActions.getWish();
      storage.set(keys.user, user);

      const rule = user && user.rule;
      const isEquivalentToSeller = rule === 'admin' || rule === 'seller';
      if (!isEquivalentToSeller && next === '/estimate-box') {
        // seller에 준하는 권한을 가진 유저가 아닌데 견적서 등록하기 버튼을 통해 로그인 시도하는 경우에 우선 홈화면으로 로그인 되도록 처리
        history.push('/');
      } else if (next) {
        history.push(next);
      } else {
        history.push('/');
      }
    } catch (e) {
      console.log(e);
      history.push('/error?code=409&message=인증 기간이 만료되었거나 사용한 이메일입니다.');
    }
  };

  componentDidMount() {
    this.initialize();
  }

  render() {
    return null;
  }
}

export default connect(
  ({ auth }: State) => ({
    authResult: auth.authResult,
  }),
  () => ({}),
)(EmailLogin);



// WEBPACK FOOTER //
// ./src/containers/etc/EmailLogin.js